import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryTypeGrantsFetchFailedAction = {
	type: 'BENEFICIARY_TYPE_GRANTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryTypeGrantsFetchFailedAction => ({
	type: 'BENEFICIARY_TYPE_GRANTS_FETCH_FAILED',
	payload,
});
